<!--
/*******************************************************************************
*@ 컴포넌트명   : DrwotAcno.vue
*@ 컴포넌트설명 : 출금계좌 컴포넌트
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <select-box
      ref="acno"
      :value.sync="selected"
      :option-list.sync="list"
      :label="label"
      :label-i18n="pageOption == 'myQr' ? 'MFXD-01-03-01-03' : 'MPAY-02-01-24-03'"
      :disabled="disabled"
      :readonly="readonly"
      :default-text.sync="defaultTextData"
      template="drwot"
      cssType="latest"
      required="required"
    >
      <template #noData>
        <div class="notice normal">
          <div class="notice-tit">
            <p>{{ /*선택 가능한 계좌가 없습니다.*/ $t("MCOM-0000083") }}</p>
          </div>
          <div class="notice-cont">
            <p>{{ /*다음과 같은 이유로 계좌가 표시되지 않습니다.*/ $t("MCOM-0000071") }}</p>
            <ol class="olist olist-number-type info-guide">
              <li>
                <span class="num">①</span>
                {{ /*출금 계좌 이외에 내 계좌가 없는 경우*/ $t("MCOM-0000072") }}
              </li>
              <li>
                <span class="num">②</span>
                {{ /*거래 가능한 통화를 가진 계좌가 없는 경우*/ $t("MCOM-0000073") }}
              </li>
              <li v-if="isCorporationUser">
                <span class="num">③</span>
                {{ /*기업 사용자의 경우 이체 권한이 없는 경우*/ $t("MCOM-0000124") }}
              </li>
            </ol>
          </div>
        </div>
      </template>
    </select-box>
    <div class="info info-etc-col">
      <div v-if="notSelectedWhenButtonClick">
        <p class="color-point">{{ $t("MPAY-05-01-01-07") }}</p>
      </div>
      <slot name="info" />
      <p v-if="page != 'transfer' && showOption.includes('dpostBal') && !_.isNil(dpostBalInfo) && pageOption !== 'myQr'">
        {{ /*출금 가능 금액*/ $t("MPAY-03-01-06-02") }} : {{ dpostBalInfo }}
      </p>
      <slot name="error" />
    </div>
  </article>
</template>
<script>
import { mapGetters } from "vuex";
import { commonProps, valueProps, selectBoxProps } from "@/mixins/basicComponent";
import { RBF0400A40 } from "@/mixins/transfer";
import { mapFields } from "vuex-map-fields";
export default {
  mixins: [commonProps, valueProps, selectBoxProps, RBF0400A40],
  props: {
    showOption: {
      type: Array,
      default: () => ["dpostBal"],
    },
    authChkYn: {
      type: String,
      default: "0",
    },
    cncycd: String,
    page: String,
    pageOption: String,
    notSelectedWhenButtonClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dpostBalInfo: null,
      list: [],
    };
  },
  async created() {
    this.$log.info(this.approvalLineInfo);
    const res = await this.RBF0400A40CallDrwot();
    if (res.length > 0) {
      this.list = res;
      if (this.siteCode == this.$config.SITECODE_OGHCM) {
        // 베트남 메인출금계좌 디폴트값 설정
        let fvrtAcno = null;
        this.list.forEach(item => {
          if (item.data.rpsntDrwotAcnYn == "1") {
            fvrtAcno = item.data;
          }
        });
        if (fvrtAcno != null) {
          let data = `${fvrtAcno.acno};${fvrtAcno.cncycd};${fvrtAcno.alias}`;
          this.setValue(data);
        }
      }
      if (!_.isEmpty(this.drwotAcno)) {
        let data = `${this.drwotAcno.acno};${this.drwotAcno.cncycd};${this.drwotAcno.alias}`;
        this.setValue(data);
        // this.$refs.acno.selectedText = `${this.drwotAcno.acno} (${this.drwotAcno.cncycd})`;
        // this.$refs.acno.selectedValue = data;
        // this.$refs.acno.selectedTselectedDataext = this.drwotAcno;
        // this.$refs.acno.selectedIndex = 0;
        // this.$emit("update:value", data);
      }
    } else {
      // alert("데이터 없음");
    }
  },
  computed: {
    ...mapFields("admin", ["approvalLineInfo"]),
    ...mapGetters(["isCorporationUser"]),
    ...mapFields(["operGroupCd", "siteCode"]),
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$log.info("drwotAcno", value);
        let selectedData = this.$refs.acno.selectedData;
        this.dpostBalInfo = selectedData == "" ? null : `${selectedData.cncycd} ${this.$num(selectedData.dpostBal)}`;

        this.drwotAcno = selectedData;
        //this.$set(this, "drwotAcno", selectedData);
        this.$emit("update:value", value);
        this.$emit("change", selectedData);
        this.$emit("update:detailValue", this.$refs.acno.selectedData);
      },
    },
    defaultTextData: {
      get() {
        return this.defaultText;
      },
      set() {
        this.$emit("update:defaultText", this.defaultText);
      },
    },
  },
  methods: {
    drwotAcnoFilter(cncycd, page) {
      this.$refs.acno.setOptionList(this.makeListDrwot(null, cncycd, page));
      this.$log.info(this.$refs.acno.selectedData);
      this.$set(this, "drwotAcno", this.$refs.acno.selectedData);
      this.$emit("update:value", this.$refs.acno.selectedValue);
      this.$emit("update:detailValue", this.$refs.acno.selectedData);
    },
    setValue(value) {
      this.$refs.acno.setValue(value);
      this.selected = value;
    },
  },
};
</script>
